import { render, staticRenderFns } from "./index.vue?vue&type=template&id=764a0da0&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=764a0da0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764a0da0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('764a0da0')) {
      api.createRecord('764a0da0', component.options)
    } else {
      api.reload('764a0da0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=764a0da0&scoped=true&", function () {
      api.rerender('764a0da0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/news/index.vue"
export default component.exports